import _ from 'lodash';
import { takeLatest, call, put } from 'redux-saga/effects';
import {
  deleteCardRequest,
  deleteCardResponse,
  getSavedCardsResponse,
} from '../../slices/customer';
import axios from '../axiosConfig';
import { setDefaultSelectedCard } from '../../slices/trip';

function* deleteCardWorker({
  payload: { card, customerId, withAddressOnly, doShowPaymentCheckboxes, paymentMethodIndex },
}) {
  try {
    const url = '/users/deleteCard';
    const config = {
      method: 'POST',
      url,
      data: JSON.stringify({
        card: card.id,
        cardId: card.cardId,
        customerId,
        withAddressOnlyCards: withAddressOnly,
        doShowPaymentCheckboxes,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);
    yield put(
      setDefaultSelectedCard({
        customerId,
        cards: data,
      }),
    );
    yield put(getSavedCardsResponse({ cards: data, customerId }));
    yield put(deleteCardResponse({ card }));
  } catch (ex) {
    console.log(ex);
    yield put(
      deleteCardResponse({
        error: (ex || {}).detail || 'Could not delete card!',
        customerId,
        card,
      }),
    );
  }
}

function* deleteCardWatcher() {
  yield takeLatest(deleteCardRequest.toString(), deleteCardWorker);
}

export default deleteCardWatcher;
